import '../packs/custom_selectize';

const DATA_TABLE_API_KEY = 'contrailDataTableApi';

// Namespace + `.off()`: este arquivo e importado por ~25 modulos de datatable, e
// alguns chegam por partial injetada com `javascript_pack_tag` no corpo
// (railway_compositions/_datatable_rct), que o jQuery reavalia a cada injecao.
// Sem isto cada reavaliacao somava mais um handler e cada init da tabela passava
// a alocar N Api sobre o mesmo no - o mesmo vazamento que custom_datatable.js
// evita com o namespace `.contrailDt`.
$(document)
  .off('init.dt.contrailRedraw')
  .on('init.dt.contrailRedraw', (_event, settings) => {
    const table = settings && settings.nTable;

    if (!table || !$.fn.dataTable) return;

    table[DATA_TABLE_API_KEY] = new $.fn.dataTable.Api(settings);
  });

export default function redrawDT(id) {
  const table = document.querySelector(id);
  const registeredDataTable = table && table[DATA_TABLE_API_KEY];
  const dataTableAvailable =
    $.fn.dataTable && typeof $.fn.dataTable.isDataTable === 'function';
  const initialized =
    Boolean(table) &&
    Boolean(dataTableAvailable) &&
    $.fn.dataTable.isDataTable(table);

  if (!registeredDataTable && !initialized) {
    return;
  }

  const $dt = registeredDataTable || $(table).DataTable();
  $dt.draw();
}

// `Window` maiusculo e o construtor da interface, nao a `window` - mas 24
// respostas `.js.slim` (layouts/redraw, layouts/close_modal, os imports de
// planilha, os approve_*) chamam literalmente `Window.redrawDT(...)`, entao esta
// linha e o que faz aquelas telas redesenharem. Apagar ou trocar para `window`
// aqui quebra as 24 sem mexer nas views junto.
if (!Window.redrawDT) Window.redrawDT = redrawDT;
